export const LOCALE_PREFIX = 'components.Tooltips.Indicators.BisnodeScoringTooltip'
export const SCORING_CODES = ['aaa', 'aa', 'a', 'bbb', 'bb', 'b', 'ccc', 'cc', 'c', 'd']
